"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextTitle1 = void 0;
var _createText = require("./createText");
const TextTitle1 = (0, _createText.createText)('title1');
exports.TextTitle1 = TextTitle1;